import { FC } from 'react';
import { useContextSelector as useCS } from 'use-context-selector';
import { Modal } from '@mui/material';
import { ProfileCreatedModalIcon, CloseIcon } from 'assets';
import { profileConfigSelectors } from 'domain/profileConfig/selectors';
import {
  ProfileConfigContext,
  TProfileConfigContextState,
} from 'domain/profileConfig/ProfileConfigContext';
import { TUpdate } from 'domain/types';
import { Button } from 'view/components';
import * as CS from 'view/modals/styled';
import { GlobalConfigContext } from 'domain/globalConfig/GlobalConfigContext';
import { globalConfigSelectors } from 'domain/globalConfig/selectors';
import { RolesEnum } from 'infrastructure/enums/RolesEnum';
import { useNavigate } from 'react-router';

const ProfileCreatedModal: FC<{ hideCloseButton?: boolean }> = ({ hideCloseButton = false }) => {
  const navigate = useNavigate();
  const isOpenProfileCreatedModal: boolean = useCS(
    ProfileConfigContext,
    profileConfigSelectors.isOpenProfileCreatedModal
  );
  const update: TUpdate<TProfileConfigContextState> | undefined = useCS(
    ProfileConfigContext,
    profileConfigSelectors.update
  );

  const { role, jobSeekerProfile } = useCS(GlobalConfigContext, globalConfigSelectors.userData);

  const onClose = () => {
    if (update) update({ isOpenProfileCreatedModal: false });
  };

  return (
    <Modal
      open={isOpenProfileCreatedModal}
      onClose={() => {}}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <CS.ModalMainWrapper>
        {!hideCloseButton ? (
          <CS.CloseIconBox onClick={onClose}>
            <CloseIcon />
          </CS.CloseIconBox>
        ) : null}
        <CS.ModalMainBox>
          <CS.ModalMainImage>
            <ProfileCreatedModalIcon />
          </CS.ModalMainImage>
          <CS.ModalMainHeader>
            <CS.ModalMainHeaderTitle>Profile successfully created!</CS.ModalMainHeaderTitle>
            <CS.ModalMainHeaderSubTitle>
              {
                'Please set up your work preferences to start exploring \n relevant recommendations.'
              }
            </CS.ModalMainHeaderSubTitle>
          </CS.ModalMainHeader>
        </CS.ModalMainBox>
        <CS.ModalMainFooter>
          <Button
            variant="outlined"
            text="Go to home"
            onClick={() => {
              if (role?.name === RolesEnum.JOB_SEEKER) {
                navigate('/profile/job-list');
              }
              if (role?.name === RolesEnum.RECRUITER) {
                navigate('/candidates/candidates-list');
              }
              onClose();
            }}
          />
          <Button
            variant="contained"
            text="View profile"
            disabled={jobSeekerProfile && !jobSeekerProfile?.hasWorkPreferencesFilled}
            onClick={() => {
              if (role?.name === RolesEnum.JOB_SEEKER) {
                navigate(`/candidates/candidate-profile?id=${jobSeekerProfile?.id}`);
              } else {
                navigate('/profile/profile-settings');
              }
              onClose();
            }}
          />
        </CS.ModalMainFooter>
      </CS.ModalMainWrapper>
    </Modal>
  );
};

export default ProfileCreatedModal;
